import mod from "-!./navbar.js?vue&type=script&lang=js&"; export default mod; export * from "-!./navbar.js?vue&type=script&lang=js&"